import React, { Component } from 'react'
import { history } from '../../../../routing/History'
import * as ROUTING_PATHS from '../../../../routing/Paths'
import { Session } from '../../../../state/utils/session'
import { Link } from 'react-router-dom'
import { jsonPrettify } from '../../../../utils/jsonPrettify'

class AccountingSeatDetailsCard extends Component {
  constructor (props) {
    super(props)

    this.state = {
      session: new Session()
    }
    this.goToAccountingSeatEditor = this.goToAccountingSeatEditor.bind(this)
  }

  goToAccountingSeatEditor () {
    history.push(
      ROUTING_PATHS.CLIENT_DASHBOARD_ACCOUNTING_SEAT_EDITOR_PATH
        .replace(':accountingSeat_id', this.props.accountingSeat.id)
        .replace(':client_id', this.state.session.getClientSession())
    )
  }

  render () {
    return (
            <>
                <div className="block">
                    <div className="block-header bg-gray-lighter">
                        <ul className="block-options">
                            <li>
                                <button type="button" onClick={this.goToAccountingSeatEditor}>
                                    <i className="fa fa-edit"></i>
                                </button>
                            </li>
                        </ul>
                        <h3 className="block-title">
                            <i className="fa fa-info-circle"></i> Details
                        </h3>
                    </div>
                    <div className="block-content">
                        <ul className="list list-activity push">
                            <li>
                                <div className="font-w600">ID:</div>
                                <div>{this.props.accountingSeat.id}</div>
                            </li>
                            <li>
                                <div className="font-w600">AccountingSeat name:</div>
                                <div>{this.props.accountingSeat.name}</div>
                            </li>
                            <li>
                                <div className="font-w600">Description:</div>
                                <div>{this.props.accountingSeat.description}</div>
                            </li>
                            <li>
                                <div className="font-w600">type:</div>
                                <div>{this.props.accountingSeat.accountingSeat_type}</div>
                            </li>
                            <li>
                                <div className="font-w600">Connection:</div>
                                <div>
                                    <Link to={
                                        ROUTING_PATHS.CLIENT_DASHBOARD_CONNECTION_DETAILS_PATH
                                          .replace(':client_id', this.state.session.getClientSession())
                                          .replace(':connection_id', this.props.accountingSeat.connection)
                                    }>
                                        {this.props.accountingSeat.connection_name}
                                    </Link>
                                </div>
                            </li>
                            <li>
                                <div className="font-w600">Active:</div>
                                <div>{JSON.stringify(this.props.accountingSeat.active)}</div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="block">
                    <div className="block-header bg-gray-lighter">
                        <ul className="block-options">
                            <li>
                                <button type="button" onClick={this.goToAccountingSeatEditor}>
                                    <i className="fa fa-edit"></i>
                                </button>
                            </li>
                        </ul>
                        <h3 className="block-title">
                            <i className="fa fa-info-circle"></i> Email Settings
                        </h3>
                    </div>
                    <div className="block-content">
                        <ul className="list list-activity push">
                            <li>
                                <div className="font-w600">Emails:</div>
                                <div>
                                    <pre>
                                        <code>
                                            {jsonPrettify(this.props.accountingSeat.emails)}
                                        </code>
                                    </pre>
                                </div>
                            </li>
                            <li>
                                <div className="font-w600">Subject:</div>
                                <div>{this.props.accountingSeat.subject}</div>
                            </li>
                            <li>
                                <div className="font-w600">Template:</div>
                                <div>{this.props.accountingSeat.template}</div>
                            </li>
                        </ul>
                    </div>
                </div>
            </>
    )
  }
}

// Set defaultProps
AccountingSeatDetailsCard.defaultProps = {
  accountingSeat: {}
}

// Export Class
export { AccountingSeatDetailsCard }
